import { TextField } from "@base/ui/TextField";
import { DatePicker, useDatePickerContext } from "@ark-ui/react";
import { mdiCalendarMonthOutline, mdiClose } from "@mdi/js";
import Icon from "@mdi/react";
import { useCallback, type ComponentProps } from "react";
import { useDatePickerCustomContext } from "../DatePickerContext";

type InputProps = ComponentProps<typeof TextField>;
type Props = InputProps;

const Input = ({ ...rest }: Props) => {
  const { setOpen, valueAsString, clearValue } = useDatePickerContext();
  const { required, readOnly } = useDatePickerCustomContext();

  const openCalendar = useCallback(() => {
    if (readOnly) {
      return;
    }

    setOpen(true);
  }, [readOnly, setOpen]);

  const handleClear = useCallback(() => {
    clearValue();
  }, [clearValue]);

  const hasValue = valueAsString && valueAsString.length > 0;

  return (
    <DatePicker.Control asChild>
      <TextField readOnly={readOnly} {...rest}>
        <TextField.Input
          required={required}
          value={valueAsString}
          onFocus={openCalendar}
          onClick={openCalendar}
          onChange={(e) => {
            e.preventDefault();
          }}
          prefix={<Icon path={mdiCalendarMonthOutline} size="1rem" />}
          suffix={
            hasValue ? (
              <button type="button" onClick={handleClear} aria-label="Clear date">
                <Icon path={mdiClose} size="1rem" />
              </button>
            ) : null
          }
        />
      </TextField>
    </DatePicker.Control>
  );
};

export default Input;
